import React, { useEffect, useCallback, useMemo, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate, useParams } from "react-router-dom";
import Paper from "@mui/material/Paper";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormDialog from "../Pricing/SubscritionModals/FreeAccount";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Config } from "../../../Utils/Config";
import moment from "moment";
import { Link } from "react-router-dom";
import PasswordStrengthMeter from "../Common/PasswordStrengthMeter/PasswordStrengthMeter";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { MyMarketList } from "../Index";
import { IconButton, MenuItem, Menu, Divider, Modal, Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Label } from "reactstrap";
import { getImageSrc, checkImpersonation } from "../../../helpers/dataHelper";
import InfiniteScroll from "react-infinite-scroller";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { encryptPayload } from "../../../Utils/crypto_utils";
import RefreshIcon from "@mui/icons-material/Refresh";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from "react-redux";
import { HubSpotForm } from "../../../helpers/componentHelper";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MyAccount = (props) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = React.useState(false);
  const [creditsCount, setCreditsCount] = React.useState({
    err: false,
    value: "",
  });
  const dispatch = useDispatch();
  const { id } = useParams();
  const packageDetail = props.packDetails;
  const [page,setPage] = React.useState(1);
  const [totalPage,setTotalPage] =React.useState(0);
  const scrollTableRef = React.useRef();
  const [isLoading, setLoading] = React.useState(false);
  const [userDetail, setUserDetail] = React.useState([]);
  const [customerOrders, setCustomerOrders] = React.useState([]);
  const [remarks, setRemarks] = React.useState("");
  const [showErr, setShowErr] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [snackClr, setSnackClr] = React.useState("");
  const [snackMsg, setSnackMsg] = React.useState("");
  const [openContactSupport, setOpenContactSupport] = React.useState(false);
  const [openAccDeletionConfirmation, setOpenAccDeletionConfirmation] =
    React.useState(false);
  const [userLogoDeleteConfirmation, setUserLogoDeleteConfirmation] =
    React.useState(false);
  const [openAccDeletion, setOpenAccDeletion] = React.useState(false);
  const [openChild, setChildOpen] = React.useState(false);
  const [openUpdatePassword, setOpenUpdatePassword] = React.useState(false);
  const [pwdDetails, setPwdDetails] = React.useState({
    confirmpassword: "",
    newpassword: "",
    oldpassword: "",
  });
  const [selectedMarket, setSelectedMarket] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [plan,setPlan] = React.useState("annually")
  const [oldPasswordErr, setOldPasswordErr] = React.useState("");
  const [newPasswordErr, setNewPasswordErr] = React.useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = React.useState("");
  const [openProSubscription, setOpenProSubscription] = React.useState(false);
  const [userLogo, setUserLogo] = React.useState(null);
  const [userMarkets, setUserMarkets] = React.useState([]);
  const [otp2fa, setOtp2fa] = useState("");
  const [otp,setOtp]=useState(false);
  const [copy,setCopy]=useState(false);
  const [cancelSubscriptionConfirmation, setCancelSubscriptionConfirmation] = useState({
    open : false,
    subscriptionId : null
  })
  const [contactUsOpen, setContactUsOpen] = useState(false);
  // closeChild
  const closeChild = useCallback(
    (show) => {
      setChildOpen(show);
    },
    [openChild]
  );

  const CallChildOpen = () => {
    setChildOpen(true);
  };

  useEffect(() => {
    if (id) {
      getUserMarkets();
    }
    fetchUserDetail();
  }, []);

  const handleChange = (event) => {
    setRemarks(event.target.value);
    setShowErr(false);
  };
  const getUserMarkets = () => {
    setLoading(true);
     apiCommonTrigger("post",`${Config.API_URL}/admin/markets`, {
           orderby: "CreatedDate",
        orderdirection: "DESC",
        page:page,
        resultsPerPage:20,
        userid: id,
        showmarketnameonly: false,
        })
      .then((res) => {
        if (res.status === 200) {
          const existingMarkets = userMarkets;
          const newMarkets = res.data.markets.filter(
            (market) =>
              !existingMarkets.some((existingMarket) => existingMarket.id === market.id)
          );

          setUserMarkets([...userMarkets,...newMarkets]);
          setTotalPage(res.data.pagination.totalpages)
          setLoading(false);
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };
  const submitCredit = () => {
    if (creditsCount.value < 0 || creditsCount.value > 999 || (!creditsCount.value&&creditsCount.value!==0)) {
      return setCreditsCount({ ...creditsCount, err: true });
    }
    setLoading(true);
     apiCommonTrigger("post",`${Config.API_URL}/admin/updateuserlimits`, {
           units: creditsCount.value,
        userid: id,
        })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            setOpenModal(false);
            getUserMarkets();
            fetchUserDetail();
          }
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };
  const handleInfiniteOnLoad=()=>{
    if (page + 1 <= totalPage && !isLoading) {
      setPage(page + 1);
    }
  }
  useEffect(()=>{
    if(id){
      getUserMarkets();
    }

  },[page])

  const handleToggleChange = (e,plan)=>{
    if(plan !== null){
      setPlan(plan)
    }
  }
  const fetchUrlAdmin =async (idx) => {
    const url = `/admin/user-subscription/${id}/${idx}`
    navigate(url);
  }
  const cancelSubscription=async (orderid)=>{
     setLoading(true);
     setCancelSubscriptionConfirmation({open : false, subscriptionId : null});
     apiCommonTrigger("post",`${Config.API_URL}/subscription/cancelsubscription`, {
          orderid: orderid,
          userid: id ? parseInt(id) : userDetail.userid,
        })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            setOpen(true);
            setSnackClr("success");
            setSnackMsg("Subscription Cancelled Successfully. Please check your email for further instructions.");
            // Refresh User Details
            if (id) {
              getUserMarkets();
            }
            fetchUserDetail();
          }
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  }
  const fetchUrl = async (idx) => {
    let encryptedPayload = await encryptPayload(idx);
    setLoading(true);
    const geturl = `/Subscription/billinghistory/${encodeURIComponent(
      encryptedPayload
    )}`;
    apiCommonTrigger("get", Config.API_URL + geturl)
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            window.open(res.headers.location, "_blank");
          }
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };
  const handleClick = (e, market) => {
    setSelectedMarket(market);
    setAnchorEl(e.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const fetchUserDetail =async () => {
    setLoading(true);
    const encryptedPayload= await encryptPayload(parseInt(id));
    const  url=id ? `/admin/userdetails/${encodeURIComponent(encryptedPayload)}` : "/account/userdetails";
    apiCommonTrigger("get",Config.API_URL+url)
      .then((res) => {
        if (res.status === 200) {
          setUserDetail(res.data.user.userdetail);
          setCreditsCount({ ...creditsCount, value: (res?.data?.user?.userdetail?.availablemarket || 0) });
          setCustomerOrders(res.data.user.customerorder);
          setOtp(false);
          //Update User Detail in Local Storage
          var usrData = JSON.parse(localStorage.getItem("user"));
          var roles = res.data.user.userdetail.role.sort((a, b) => {
            return b.orderby - a.orderby;
          });
          usrData.usertype = roles[0].name;
          usrData.username = res.data.user.userdetail.firstname;
          id ? null : localStorage.setItem("user", JSON.stringify(usrData));
          if(!id){
            dispatch({ type: "userDetails", value: usrData });
          }

          if (res.data.user.userdetail.showuserlogo) {
            const logo = getImageSrc(res.data.user.userdetail.userlogoblob);
            setUserLogo(logo);
          }
          setLoading(false);
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };

  const handleSubmit = () => {
    if (remarks === "") {
      setShowErr(true);
    } else {
      setLoading(true);
        apiCommonTrigger("post",`${Config.API_URL}/account/contactsupport`, {
          Remarks: remarks,
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data === "success") {
              setLoading(false);
              setRemarks("");
              setOpenContactSupport(false);
              setOpen(true);
              setSnackClr("success");
              setSnackMsg("Your Request has been submitted successfully.");
            }
          } else {
            setLoading(false);
            handlingCatchError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          handlingCatchError(err, navigate);
        });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const onModalClose = () => {
    setCancelSubscriptionConfirmation({open:false,subscriptionId:null});
    setShowErr("");
    setRemarks("");
    setOpenAccDeletion(false);
    setOpenAccDeletionConfirmation(false);
    setUserLogoDeleteConfirmation(false);
    setOpenContactSupport(false);
    setPwdDetails({});
    setOldPasswordErr("");
    setNewPasswordErr("");
    setConfirmPasswordErr("");
    setOpenUpdatePassword(false);
    setOpenProSubscription(false);
  };

  const openConfirmDeletion = () => {
    setOpenAccDeletionConfirmation(false);
    setOpenAccDeletion(true);
  };

  const updateProSubscription = () => {
    if (localStorage.getItem("impersonated") === "true") {
      checkImpersonation();
    } else {
      setLoading(true);
      let inputData={   lookupkey: plan === "annually" ? packageDetail.ProLookupKey : packageDetail.QuartLookupKey,}
        apiCommonTrigger("post",`${Config.API_URL}/subscription/upgrade`,inputData)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            window.open(res.headers.location, "_self");
            setOpenProSubscription(false);
          } else {
            setLoading(false);
            handlingCatchError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          handlingCatchError(err, navigate);
        });
    }
  };

  const accountDeletion = () => {
    setLoading(true);
    apiCommonTrigger("delete",Config.API_URL+"/account/deleteaccount")
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            localStorage.clear();
            navigate("/invalid-access");
          }
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };

  const getMarketCredit = () => {
    if (localStorage.getItem("impersonated") === "true") {
      checkImpersonation();
    } else {
      setLoading(true);
       let inputData={  lookupkey: packageDetail.LookupKey,}
        apiCommonTrigger("post",`${Config.API_URL}/subscription/buymarketcredit`,inputData)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            window.open(res.headers.location, "_self");
          } else {
            setLoading(false);
            handlingCatchError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          handlingCatchError(err, navigate);
        });
    }
  };
const isAdmin=localStorage.getItem("isAdmin");
  const onChangePwdValidation = (e) => {
    // New Password validation
    if (e.target.name === "newpassword") {
      //   var regName = /^(.{0,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{4,})|(.{1,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{3,})|(.{2,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{2,})|(.{3,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{1,})|(.{4,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{0,})$/;
      //   var name = e.target.value;
      //   if (name.length === 0) {
      //     setNewPasswordErr('Password required');
      //   } else {
      //     if (!regName.test(name)) {
      //         setNewPasswordErr('Passwords are case-sensitive.');
      //     } else {
      //       if (name.length <= 5) {
      //         setNewPasswordErr('Your Password must be 6 characters');
      //       } else if (name.length >= 26) {
      //         setNewPasswordErr('Your Password maximum limit is 25 characters');
      //       } else {
      //         if (pwdDetails.confirmPassword && pwdDetails.confirmPassword !== name) {
      //           setConfirmPasswordErr('Password does not match.');
      //           setNewPasswordErr('');
      //         } else {
      //             if(name === pwdDetails.oldPassword){
      //                 setNewPasswordErr('Current password and New password cannot be same');
      //             }else{
      //                 setNewPasswordErr('');
      //                 setConfirmPasswordErr('');
      //             }
      //         }
      //       }
      //     }
      //   }

      let password = e.target.value;
      setPwdDetails({
        ...pwdDetails,
        newpassword: e.target.value,
      });
      setNewPasswordErr("");
      let capsCount, smallCount, numberCount, symbolCount;
      if (password.length < 4) {
        setNewPasswordErr(
          "Password must be minimum 4 characters include one UPPERCASE, lowercase, number and special character: @$! % * ? &"
        );
        return;
      } else {
        capsCount = (password.match(/[A-Z]/g) || []).length;
        smallCount = (password.match(/[a-z]/g) || []).length;
        numberCount = (password.match(/[0-9]/g) || []).length;
        symbolCount = (password.match(/\W/g) || []).length;
        if (capsCount < 1) {
          setNewPasswordErr("Must contain one UPPERCASE letter");
          return;
        } else if (smallCount < 1) {
          setNewPasswordErr("Must contain one lowercase letter");
          return;
        } else if (numberCount < 1) {
          setNewPasswordErr("Must contain one number");
          return;
        } else if (symbolCount < 1) {
          setNewPasswordErr("Must contain one special character: @$! % * ? &");
          return;
        }

        if (
          pwdDetails.confirmpassword &&
          pwdDetails.confirmpassword !== password
        ) {
          setConfirmPasswordErr("Password does not match.");
          setNewPasswordErr("");
          return;
        } else {
          setNewPasswordErr("");
          setConfirmPasswordErr("");
          return;
        }
      }
    }

    // Confirm password validation
    if (e.target.name === "confirmpassword") {
      var name = e.target.value;
      if (name.length === 0) {
        setConfirmPasswordErr("Confirm password required");
      } else {
        if (name === pwdDetails.newpassword) {
          if (name === pwdDetails.oldpassword) {
            setConfirmPasswordErr(
              "Current password and confirm Password cannot be same"
            );
          } else {
            setConfirmPasswordErr("");
          }
        } else {
          setConfirmPasswordErr("Password does not match");
        }
      }
    }

    // Confirm password validation
    if (e.target.name === "oldpassword") {
      var name = e.target.value;
      if (name.length === 0) {
        setOldPasswordErr("Password required");
      } else {
        if (name === pwdDetails.newpassword) {
          setNewPasswordErr(
            "Current password and new password cannot be same."
          );
        } else if (name === pwdDetails.confirmpassword) {
          setConfirmPasswordErr(
            "Current password and confirm password cannot be same."
          );
        } else {
          setOldPasswordErr("");
          setNewPasswordErr("");
          setConfirmPasswordErr("");
        }
      }
    }
    setPwdDetails({ ...pwdDetails, [e.target.name]: e.target.value });
  };

  const onHandleSubmitPassword = (e) => {
    e.preventDefault();
    if (
      !confirmPasswordErr &&
      !newPasswordErr &&
      pwdDetails.newpassword &&
      pwdDetails.confirmpassword &&
      id
    ) {
      setLoading(true);
      formPasswordUpdate();
    } else if (
      !oldPasswordErr &&
      !confirmPasswordErr &&
      !newPasswordErr &&
      pwdDetails.newpassword &&
      pwdDetails.confirmpassword &&
      pwdDetails.oldpassword
    ) {
      setLoading(true);
      formPasswordUpdate();
    } else {
      if (oldPasswordErr === "" && !pwdDetails.oldpassword) {
        setOldPasswordErr("Please fill out this field");
      }
      if (confirmPasswordErr === "" && !pwdDetails.confirmpassword) {
        setConfirmPasswordErr("Please fill out this field");
      }
      if (newPasswordErr === "" && !pwdDetails.newpassword) {
        setNewPasswordErr("Please fill out this field");
      }
    }
  };
  const handle2faotpgenerate =async (userid) => {
    try{
     
 const res = await apiCommonTrigger("get",`${Config.API_URL}/admin/generate-otp/`,[userid]);
    if (res.status === 200) {
      setOtp2fa(res.data.code);
      setOtp(true);
    }
    }
   catch(err){
    handlingCatchError(err);
   }
  };
  const handleCopyotp=(copyotp)=>{
    navigator.clipboard.writeText(copyotp);
    setCopy(true);
    setTimeout(() => setCopy(false), 2000);

  }

  const formPasswordUpdate = () => {
    let payload = id
      ? {
          userid: id,
          Password: pwdDetails.newpassword,
          ConfirmPassword: pwdDetails.confirmpassword,
        }
      : {
          CurrentPassword: pwdDetails.oldpassword,
          Password: pwdDetails.newpassword,
          ConfirmPassword: pwdDetails.confirmpassword,
        };
    setLoading(true);
    let url = id ? "/admin/resetuserpassword" : "/account/resetuserpassword"
     apiCommonTrigger("post",`${Config.API_URL}${url}`, payload) 
      .then((res) => {
        // return res;
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            setOpen(true);
            setSnackClr("success");
            setSnackMsg("Your new password has been updated successfully.");
            onModalClose();
          }
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };

  const [isStrength, setStrength] = React.useState(null);
  const dataHandler = async (childData) => {
    setStrength(childData);
  };

  var userDetails =
    localStorage.getItem("user") !== null ? localStorage.getItem("user") : null;
  var isFreeUser =
    userDetails !== null && JSON.parse(userDetails).usertype === "Free"
      ? true
      : false;
  var isBasicUser =
    userDetails !== null && JSON.parse(userDetails).usertype === "Basic"
      ? true
      : false;

  const deleteLogo =async () => {
    setLoading(true);
    const encryptedpayload = await encryptPayload(parseInt(id))
     const url= id ? `/admin/deleteuserlogo/${encodeURIComponent(encryptedpayload)}`: "/account/deleteuserlogo";
    apiCommonTrigger("delete",Config.API_URL+url)
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            setUserLogoDeleteConfirmation(false);
            fetchUserDetail();
          }
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };

  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <Row className="m-0">
        <h5 className="account-heading">Account Details</h5>
        <Col className="ps-0">
          <div className="my-account-details">
            <Row className="m-0">
              <Col xs={userDetail?.showuserlogo ? 8 : 12} className="ps-0">
                <Col xs={12}>
                  <h6>Full Name</h6>
                  <p>
                    {userDetail.firstname ? userDetail.firstname : "-"}{" "}
                    {userDetail.lastname ? userDetail.lastname : "-"}
                  </p>
                </Col>
                <Col xs={12}>
                  <h6>Company Name</h6>
                  <p>{userDetail.company ? userDetail.company : "-"}</p>
                </Col>
                <Col xs={12}>
                  <h6>Phone Number</h6>
                  <p>{userDetail.phone ? userDetail.phone : "-"}</p>
                </Col>
                <Col xs={12}>
                  <h6>Email Address</h6>
                  <p>{userDetail.email ? userDetail.email : "-"}</p>
                </Col>
             {id || isAdmin ? (
  <>
    <Col xs={12}>
      <h6>Two Factor Authentication</h6>
      <p>
        {userDetail.is2faenabled == true ? (
          <span style={{ color: "green" }}>Enabled</span>
        ) : (
          <span style={{ color: "red" }}>Disabled</span>
        )}
      </p>
    </Col>

    {userDetail?.twofactorcode ? (
      <Col>
        <div className="d-flex">
          <h6 style={{ fontWeight: "bold", marginRight: '5px' }}>OTP : </h6>
          <h6 style={{ marginRight: '5px' }}>
            {otp ? otp2fa : userDetail.twofactorcode}
          </h6>

          <ContentCopyIcon
            onClick={() => handleCopyotp(otp ? otp2fa : userDetail.twofactorcode)}
            style={{ cursor: 'pointer', marginRight: '5px' }}
            fontSize="small"
          />
          <RefreshIcon
            onClick={() => handle2faotpgenerate(userDetail.userid)}
            style={{ cursor: 'pointer' }}
            fontSize="small"
          />
        </div>
        {copy && (
          <span style={{ fontSize: '13px', color: 'green' }}>Copied!</span>
        )}
      </Col>
    ) : null}
  </>
) : ""}

                {JSON.parse(localStorage.getItem("user")).usertype === "Free" ||
                JSON.parse(localStorage.getItem("user")).usertype ===
                  "Basic" ? (
                  <Col xs={12}>
                    <h6>Prepaid Market Purchased</h6>
                    <p>
                      {userDetail && userDetail.availablemarket
                        ? userDetail.availablemarket
                        : "-"}{" "}
                      Available Market Report(s)
                    </p>
                  </Col>
                ) : (
                  ""
                )}
              </Col>
              {userDetail?.showuserlogo ? (
                <Col xs={4} className="p-0 logo-details">
                  <h6>Your Logo Details:</h6>
                  {userDetail?.userlogoblob ? (
                    <img
                      src={userLogo}
                      style={{ width: "100%" }}
                      alt="User Logo"
                    />
                  ) : (
                    <div className="no-logo-message">
                      No logo found. You can update your new logo by clicking
                      the "Edit Account" button.
                    </div>
                  )}
                  {userDetail?.userlogoblob ? (
                    <a
                      href="#"
                      style={{ marginLeft: "0" }}
                      onClick={() => setUserLogoDeleteConfirmation(true)}
                      className="delete-account-btn"
                    >
                      <DeleteIcon />
                    </a>
                  ) : (
                    ""
                  )}
                </Col>
              ) : (
                ""
              )}
            </Row>
            <Row className="my-account-btns">
              <Col xs={12}>
                <p className="reset-txt">
                  Do you want reset your password?{" "}
                  <a href="#" onClick={() => setOpenUpdatePassword(true)}>
                    Click Here
                  </a>
                </p>
              </Col>
              <Col xs={12}>
                {userDetail &&
                userDetail.role &&
                !id &&
                userDetail.role.length > 0 &&
                userDetail.role[0].name === "Free" ? (
                  <p className="explore-more">
                    If you want to explore more features please upgrade to{" "}
                    <a href="#" onClick={() => setOpenProSubscription(true)}>
                      Pro Subscription
                    </a>
                  </p>
                ) : (
                  ""
                )}
                <button
                  onClick={() => CallChildOpen()}
                  className="edit-account-btn "
                >
                  <EditIcon />
                  Edit Account
                </button>
                {userDetail &&
                userDetail.role &&
                !id &&
                userDetail.role.length > 0 &&
                userDetail.role[0].name === "Free" ? (
                  <a
                    href="#"
                    onClick={() => setOpenAccDeletionConfirmation(true)}
                    className="delete-account-btn"
                    
                  >
                    <DeleteIcon /> Delete Account
                  </a>
                ) : (
                  ""
                )}
                {userDetail &&
                userDetail.role &&
                !id &&
                userDetail.role.length > 0 &&
                userDetail.role[0].name === "Free" ? (
                  <a
                    href="#"
                    onClick={() => getMarketCredit()}
                    className={
                      customerOrders &&
                      customerOrders.length > 0 &&
                      !(localStorage.getItem("isAdmin") === "true")
                        ? "order-col-enabled buy-report-btn"
                        : "buy-report-btn"
                    }
                  >
                    <ShoppingCartIcon />
                    {`Buy Market Report @ ${packageDetail.Currency}${packageDetail.Single_Market_Price} plus data access`}{" "}
                  </a>
                ) : (
                  ""
                )}
               {isAdmin===true?<p className="text-right">
                  Need any help?{" "}
                  <a href="#" onClick={() => setOpenContactSupport(true)}>
                    Contact Support
                  </a>
                </p>:<></>}  {!isAdmin==true?<p className="text-right">
                  Need any help?{" "}
                  <a href="#" onClick={() => setOpenContactSupport(true)}>
                    Contact Support
                  </a>
                </p>:<></>}
               
              </Col>
            </Row>
          </div>
        </Col>
        {customerOrders && customerOrders.length > 0 ? (
          <Col>
            <div className="order-info-details">
              <TableContainer>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="table-design"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Order For</TableCell>
                      <TableCell>Order Date</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Expired</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell></TableCell>
                      <TableCell>Cancel</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customerOrders && customerOrders.length > 0 ? (
                      customerOrders.map((row) => (
                        <TableRow
                          key={row.orderid}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.orderfor}
                          </TableCell>
                          <TableCell>
                            {row.orderdate
                              ? moment(row.orderdate).format("DD-MMM-YYYY")
                              : "-"}
                          </TableCell>
                          <TableCell>
                        {row.status === "Temporary"
                              ? "-"
                              : row.totalprice
                              ? row.currency +
                                row.totalprice.toLocaleString(undefined, {
                                  maximumFractionDigits: 2,
                                })
                              : "-"}
                          </TableCell>
                          <TableCell>
                            {row.validtill
                              ? moment(row.validtill).format("DD-MMM-YYYY")
                              : "-"}
                          </TableCell>
                          <TableCell className="font-weight">
                            {row.status === "Temporary"
                              ? "Pending"
                              : row.status}{" "}
                          </TableCell>
                          <TableCell>
                            {row.type === "onetime" ||
                            row.type === "free" || row.payment === false || row.status === "Temporary" ? null : (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => id? fetchUrlAdmin(row.orderid) : fetchUrl(row.orderid)}
                                className="view-billing-info"
                              >
                                View Billing Info
                              </Button>
                            )}
                          </TableCell>
                          <TableCell>
                          {row.type === "onetime" ||
                            row.type === "free" || row.payment === false || row.paymentstatus === "Cancelled" || row.status === "Temporary" ? '-' :  (
                            <a className="text-primary add_credits" onClick={(e)=> {
                              e.preventDefault();
                              setCancelSubscriptionConfirmation({open : true, subscriptionId : row.orderid});
                            }}>Cancel</a>
                            )}
                            </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          style={{ textAlign: "center" }}
                          colSpan="5"
                          className="store-no-data"
                        >
                          No orders found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Col>
        ) : null}
      </Row>
      <Row>
        <Col>
          {id ? (
            <div className="common-table">
              <div className="d-flex justify-content-between align-items-center">
                <h2>User Markets</h2>
                {userDetail &&
                userDetail.role &&
                userDetail.role.length > 0 &&
                userDetail.role[0].name !== "Unlimited" ? (
                  <div className="d-flex available_credits">
                    <p className="ava_label">Available Credits:</p>
                    <p className="ava_val">
                      {userDetail.availablemarket || "N/A"}
                    </p>
                    <a
                      onClick={() => setOpenModal(true)}
                      className="text-primary add_credits"
                    >
                      {userDetail.availablemarket ? "Update" : "Add" }
                    </a>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="my-markets-table">
                <InfiniteScroll
                  initialLoad={false}
                  loadMore={handleInfiniteOnLoad}
                  hasMore={page <= totalPage}
                  threshold={20}
                  useWindow={false}
                  getScrollParent={() => scrollTableRef.current}
                >
                  <TableContainer
                    component={Paper}
                    className="table-design"
                    ref={scrollTableRef}
                    style={{maxHeight:450,overflow:'auto'}}
                  >
                    <Table sx={{ minWidth: 650 }} stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Name of Market</TableCell>
                          <TableCell align="center">Radius (MILES)</TableCell>
                          <TableCell align="center">No Of RVParks</TableCell>
                          <TableCell align="right">Created Date</TableCell>
                          {/* <TableCell align="right">Actions</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {userMarkets && userMarkets?.length > 0 ? (
                          userMarkets.map((markets) => (
                            <TableRow key={markets.id}>
                              <TableCell align="left">
                                <Label className="mb-0">
                                  {markets.marketname || "-"}
                                </Label>
                              </TableCell>
                              <TableCell align="center">
                                {markets.supplyradius || "-"}
                              </TableCell>
                              <TableCell align="center">
                                {markets.rvparkscount || "-"}
                              </TableCell>
                              <TableCell align="right">
                                {moment(markets.createddate).format(
                                  "DD-MMM-YYYY"
                                ) === "Invalid date"
                                  ? "-"
                                  : moment(markets.createddate).format(
                                      "DD-MMM-YYYY"
                                    )}
                              </TableCell>
                              {/* <TableCell align="right">
                              <IconButton
                                onClick={(e) => handleClick(e, markets)}
                              >
                                <MoreHorizIcon />
                              </IconButton>
                            </TableCell> */}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              style={{ textAlign: "center" }}
                              colSpan="5"
                              className="store-no-data"
                            >
                              No records found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </InfiniteScroll>
              </div>
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>
      {/* <Menu
        open={openMenu}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        id="account-menu"
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "grey",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        className="more-option"
      >
        <MenuItem className="marketname-edit">
          <Link
            to={"/market-dashboard/interactive-map/" + selectedMarket?.id}
            state={selectedMarket}
          >
            <VisibilityOutlinedIcon />
            View on Map
          </Link>
        </MenuItem>
        <Divider />
        <MenuItem>
          <Link
            to="/market-search"
            state={{
              marketInfo: selectedMarket,
              isFrom: "/admin/user-account",
            }}
          >
            <ModeEditOutlinedIcon /> Edit
          </Link>
        </MenuItem>
        <Divider />
        <MenuItem className="delete-option">
          <DeleteOutlinedIcon /> Delete
        </MenuItem>
      </Menu> */}
      <Snackbar
        open={open}
        autoHideDuration={openUpdatePassword ? 10000 : 2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={snackClr} sx={{ width: "100%" }}>
          {snackMsg}
        </Alert>
      </Snackbar>
      <Dialog
        open={
          openContactSupport ||
          openAccDeletionConfirmation ||
          openAccDeletion ||
          openUpdatePassword ||
          openProSubscription ||
          userLogoDeleteConfirmation || 
          cancelSubscriptionConfirmation?.open
        }
        className={
          openProSubscription
            ? "modal-custom-popup pro-subscription-modal"
            : userLogoDeleteConfirmation
            ? "modal-custom-popup delete-logo-popup"
            : "modal-custom-popup"
        }
      >
        <form id="RVParkIQ_myaccount_form">
          <DialogTitle>
            {openContactSupport
              ? "Contact Support"
              : openAccDeletionConfirmation
              ? "Delete Account"
              : openAccDeletion
              ? "Your account has been deleted you will receive an email confirmation soon."
              : openUpdatePassword
              ? "Update Your Password"
              : openProSubscription
              ? "Pro Subscription"
              : userLogoDeleteConfirmation
              ? "Delete logo"
              : cancelSubscriptionConfirmation?.open 
              ? "Cancel Subscription"
              : null}
          </DialogTitle>
          <DialogContent>
            {openContactSupport ? (
              <React.Fragment>
                <TextField
                  id="outlined-multiline-static"
                  label="Enter your message here"
                  multiline
                  rows={4}
                  defaultValue=""
                  fullWidth
                  onChange={(event) => handleChange(event)}
                  className="textbox-custom"
                />
                {showErr ? (
                  <p style={{ color: "red", fontSize: "11px" }}>
                    This is required field
                  </p>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : openAccDeletionConfirmation ? (
              <React.Fragment>
                <p className="ft-14">
                  Deleting your account is an irrevocable process. You will not
                  be able to recover your account. You will need to create a new
                  one if you decide to sign up again. Please confirm you want to
                  continue deleting your account.
                </p>
              </React.Fragment>
            ) : userLogoDeleteConfirmation ? (
              <p className="ft-14">Are you sure wants to delete your logo?</p>
            ) : openAccDeletion ? (
              <React.Fragment>
                <p className="ft-14">Thank you for using RV Parks.</p>
                <p className="mt-2 ft-14">
                  We are continously improving RV Parks- Please check back with
                  us again. We welcome you back at any time. If you have any
                  questions regarding the cancellation of your subscription
                  please contact us at {Config.PhoneNumber}.
                </p>
              </React.Fragment>
            ) : openUpdatePassword ? (
              <React.Fragment>
                <Row>
                  {id ? (
                    ""
                  ) : (
                    <Col xs={12}>
                      <TextField
                        label="Current Password"
                        id="outlined-password-input"
                        fullWidth
                        value={
                          pwdDetails.oldpassword ? pwdDetails.oldpassword : ""
                        }
                        name="oldpassword"
                        onChange={(e) => onChangePwdValidation(e)}
                        error={!!oldPasswordErr}
                        helperText={oldPasswordErr ? oldPasswordErr : null}
                        type="password"
                        margin="normal"
                        required
                        className="textbox-custom"
                      />
                    </Col>
                  )}
                  <Col xs={12}>
                    <TextField
                      label="New Password"
                      id="outlined-password-input"
                      fullWidth
                      value={
                        pwdDetails.newpassword ? pwdDetails.newpassword : ""
                      }
                      name="newpassword"
                      onChange={(e) => onChangePwdValidation(e)}
                      error={!!newPasswordErr}
                      helperText={newPasswordErr ? newPasswordErr : null}
                      type="password"
                      margin="normal"
                      required
                      className="textbox-custom"
                    />
                    {pwdDetails.newpassword &&
                    pwdDetails.newpassword != null ? (
                      <PasswordStrengthMeter
                        password={pwdDetails.newpassword}
                        actions={dataHandler}
                      />
                    ) : null}
                  </Col>
                  <Col xs={12}>
                    <TextField
                      label="Confirm Password"
                      id="outlined-password-input"
                      margin="normal"
                      fullWidth
                      value={
                        pwdDetails.confirmpassword
                          ? pwdDetails.confirmpassword
                          : ""
                      }
                      name="confirmpassword"
                      onChange={(e) => onChangePwdValidation(e)}
                      error={!!confirmPasswordErr}
                      helperText={
                        confirmPasswordErr ? confirmPasswordErr : null
                      }
                      type="password"
                      required
                      className="textbox-custom"
                    />
                  </Col>
                </Row>
              </React.Fragment>
            ) : openProSubscription ? (
              <React.Fragment>
              <div className="feature-matrix price-info">
                 <ToggleButtonGroup
                   value={plan}
                   exclusive
                   onChange={handleToggleChange}
                   sx={{
                     backgroundColor: "#fff",
                     borderRadius: "20px",
                     padding: "2px",
                   }}>
                   <ToggleButton
                     value="annually"
                     sx={{
                       textTransform: "none",
                       border: "none",
                       "&.Mui-selected": {
                         backgroundColor: "#f15d47",
                         color: "white",
                         "&:hover": { backgroundColor: "#f15d47" },
                       },
                     }}>
                     Annually
                   </ToggleButton>
                   <ToggleButton
                     value="quarterly"
                     sx={{
                       textTransform: "none",
                       border: "none",
                       "&.Mui-selected": {
                         backgroundColor: "#f15d47",
                         color: "white",
                         "&:hover": { backgroundColor: "#f15d47" },
                       },
                     }}  >
                     Quarterly
                   </ToggleButton>
                 </ToggleButtonGroup>
               </div>
                {plan === "annually" &&(
                             <p className="ft-14 text-center price">
                               Starting at{" "}
                              <b>
                               {packageDetail.Currency +
                                      packageDetail.ProSubscriptionPrice +
                                     "/" +
                                     packageDetail.Period}
                               </b>
                              
                             </p>)}
                <p className="mt-2 ft-14">
                  Get complete access to the entire application with the ability
                  to create an unlimited number of market reports.
                </p>
                <Row>
                  <Col xs={12} className="modal-pro-subscription">
                    <h6>Full RV Park Profile</h6>
                    <ul>
                      <li>Property Details</li>
                      <li>Amenities and Features</li>
                      <li>Rate Details</li>
                      {/* <li>Marketing</li> */}
                      <li>Ownership</li>
                      <li>Valuation and Debt</li>
                      <li>Transaction History</li>
                      <li>Seasonality</li>
                    </ul>
                  </Col>
                  <Col xs={12} className="modal-pro-subscription">
                    <h6>Market Dynamics Score</h6>
                    <ul>
                      <li>Market Demand Score</li>
                      <li>Market Supply Factors</li>
                    </ul>
                  </Col>
                  <Col xs={12} className="modal-pro-subscription">
                    <h6>Full Population Center Profile</h6>
                    <ul>
                      <li>RV Parks in market</li>
                      <li>Average price per night</li>
                      <li>Average size of park</li>
                      {/* <li>Rental availability</li> */}
                      <li>Population</li>
                      <li>Population density</li>
                      <li>Region Type</li>
                      <li>Income per capita</li>
                      {/* <li>Average fuel cost</li> */}
                      <li>Average age</li>
                      <li>Age cohorts</li>
                      {/* <li>Ethnicity</li>
                      <li>Ethnicity cohorts</li>
                      <li>Gender percentages</li> */}
                    </ul>
                    <h6>Unlimited Market Analysis Reports</h6>
                  </Col>
                </Row>
              </React.Fragment>
            ) : cancelSubscriptionConfirmation.open ?  (
              "Are you sure wants to cancel this subscription?"
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions className="pro-footer">
            {openContactSupport ? (
              <React.Fragment>
                <Button onClick={() => onModalClose()} className="reset-opt">
                  Cancel
                </Button>
                <Button onClick={() => handleSubmit()} className="market-btn">
                  Submit
                </Button>
              </React.Fragment>
            ) : openAccDeletionConfirmation || userLogoDeleteConfirmation ? (
              <React.Fragment>
                <Button onClick={() => onModalClose()} className="reset-opt">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    userLogoDeleteConfirmation
                      ? deleteLogo()
                      : openConfirmDeletion();
                  }}
                  className="market-btn"
                >
                  Confirm Deletion
                </Button>
              </React.Fragment>
            ) : openAccDeletion ? (
              <Button onClick={() => accountDeletion()} className="market-btn">
                OK
              </Button>
            ) : openUpdatePassword ? (
              <React.Fragment>
                <Button onClick={() => onModalClose()} className="reset-opt">
                  Cancel
                </Button>
                <Button
                  onClick={(e) => onHandleSubmitPassword(e)}
                  type="submit"
                  className="market-btn"
                >
                  Submit
                </Button>
              </React.Fragment>
            ) : openProSubscription ? (
              <React.Fragment>
                <Button onClick={() => onModalClose()} className="reset-opt">
                  Cancel
                </Button>
                 <Button
                  onClick={() => {
                    if (plan === "annually") {
                      updateProSubscription();
                    } else {
                      setContactUsOpen(true);
                    }
                  }}
                  className="market-btn"
                >
                  {plan === "annually" ? "Subscribe" : "Contact us"}
                </Button>
                <HubSpotForm contactUsOpen={contactUsOpen} setContactUsOpen={setContactUsOpen}/>
              </React.Fragment>
            ) : cancelSubscriptionConfirmation.open ? (
              <React.Fragment>
                <Button onClick={() => onModalClose()} className="reset-opt">
                  No
                </Button>
                <Button
                  onClick={() =>
                    cancelSubscription(
                      cancelSubscriptionConfirmation.subscriptionId
                    )
                  }
                  className="market-btn"
                >
                  Yes
                </Button>
              </React.Fragment>
            ) : (
              ""
            )}
            {/* <Button onClick={handleClose}>Subscribe</Button> */}
          </DialogActions>
        </form>
      </Dialog>
      {openChild ? (
        <FormDialog
          id={id}
          openChild={openChild}
          closeChild={closeChild}
          userDetail={userDetail}
          isAdmin={isAdmin}
          refresh={() => fetchUserDetail()}
        />
      ) : (
        ""
      )}
      <Modal open={openModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            padding: "30px",
          }}
          className="add_credit_popup"
        >
          <h4 className="text-center mb-3 title">{userDetail.availablemarket ? "Update" : "Add"} Credits</h4>
          <TextField
            error={creditsCount.err}
            label="Credits"
            size="small"
            type="number"
            autoComplete="off"
            value={creditsCount.value}
            onKeyDown={(event)=> {
              if (event?.key === '-' || event?.key === '+' || event?.key === '.') event.preventDefault();
            }}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value)) {
                setCreditsCount({ err: false, value: e.target.value });
              }
            }}
            className="w-100 textbox-custom"
            helperText={
              creditsCount.err
                ? creditsCount.value <= 0
                  ? "Minimum Limit is 0"
                  : "Maximum Limit is 999"
                : ""
            }
          />
          <div className="d-flex justify-content-end mt-3 align-items-center gap-2">
            <Button
              className="reset-opt"
              onClick={() => {
                setOpenModal(false); 
                setCreditsCount({ ...creditsCount, value: (res?.data?.user?.userdetail?.availablemarket || 0) , err: false });
              }}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              className="market-btn rounded-3"
              variant="contained"
              onClick={submitCredit}
            >
              Submit
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default MyAccount;
